import * as net from 'util/Net';

import {FeedbackContextItem} from './LLMFeedbackConstants';

export async function submitLLMFeedback(
  feature: string,
  feedback: string,
  context: Array<FeedbackContextItem>
): Promise<void> {
  await net.postJSONPromise({
    url: '/1/api/llm/feedback',
    data: {
      feature,
      feedback,
      context,
    },
  });
}
